<template>
  <div class="chart-dialog">
    <el-dialog
      title="多次考试名次对比(进步人数/总人数)"
      :visible.sync="examRankComparisonTableDialogShow"
      width="900px"
      :before-close="dialogClose"
    >
      <!-- <div class="exam-title">对比考试：第一次期末考试</div> -->
      <div style="display: flex; justify-content: center; margin-top: 20px">
        <el-table :data="examRankComparisonList" border style="width: 100%">
          <el-table-column label="考试名称" align="center">
            <template slot-scope="scope">
              {{ scope.row.className }} - {{ scope.row.firstExamName }} -
              {{ scope.row.nextExamName }}
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in examRankComparisonList[0].rankInfoList"
            :key="item.rank"
            :label="'指定名次' + '(' + item.rank + ')'"
            align="center"
          >
            <template slot-scope="{ row }">
              {{ row.rankInfoList[index].advanceBeforeRank }}/{{
                row.rankInfoList[index].totalBeforeRank
              }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="display: flex; justify-content: center; margin-top: 50px" v-hasPermi="'sc:score:export'">
        <el-button type="primary" @click="deriveExcel">导出为excel</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { baseURL } from "@/api/request"; // 服务器地址
export default {
  props: [
    "examRankComparisonTableDialogShow",
    "examRankList",
    "examRankComparisonList",
    "gradeSelectList",
  ],
  data() {
    return {};
  },
  methods: {
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:examRankComparisonTableDialogShow", false);
    },
    // 导出为excel
    deriveExcel() {
      const rankings = this.examRankList.join(",");
      const examInfoIds = this.gradeSelectList.join(",");
      let action = `${baseURL}${this.$url.scoreAssignedPositionExcel}?examInfoIds=${examInfoIds}&rankings=${rankings}`;
      window.open(action);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./examRankComparisonTableDialog.scss";
</style>